import { Spinner } from "keep-react";

interface StandartAppButtonProps {
  type: "submit" | "button";
  buttonColor: string;
  isDisabled: boolean;
  isLoading?: boolean;
  children: React.ReactNode;
}

export const StandartAppButton = ({
  type,
  buttonColor,
  isDisabled,
  children,
  isLoading,
}: StandartAppButtonProps) => {
  return (
    <button
      type={type}
      className="px-4 py-2 rounded text-center md:w-auto disabled:opacity-50 disabled:cursor-not-allowed flex items-center justify-center gap-2"
      style={{
        background: buttonColor,
        color: "white",
      }}
      disabled={isDisabled || isLoading}
    >
      {isLoading && <Spinner color="primary" />}
      {children}
    </button>
  );
};
